import myUtil from '../../util';
import {
  knb
} from '../../../constant/sdk';

export default (BaseAdapter) => class KNBAdapter extends BaseAdapter {
  constructor(sdk) {
    super(sdk);
    this.platform = 'knb';
  }
  static canUse() {
    const env = myUtil.getEnv();
    return Promise.resolve(env === 'knb');
  }
  static load() {
    const ver = myUtil.getVersion();
    return myUtil.loadSDK(knb.version[ver])
      .then(() => {
        if (window.KNB === undefined) {
          return Promise.reject(new Error('Load KNB SDK error!'));
        }
        return Promise.resolve(window.KNB);
      });
  }
  config(opts = {}) {
    const configOpts = Object.assign({
      bizname: 'BEXT',
      debug: false
    }, opts);
    window.owl?.('addLog', 'knb before config');
    this.sdk.config(configOpts);
    window.owl?.('addLog', 'knb after config');
    return Promise.race([
      new Promise((resolve, reject) => {
        const startTime = Date.now()
        window.owl?.('addLog', 'knb before ready');
        this.sdk.ready(() => {
          window.owl?.('addLog', `knb after ready, spend time:${Date.now() - startTime}`);
          resolve();
        });
      }),
      new Promise((resolve, reject) => {
        window.owl?.('addLog', 'knb ready timeout 5000ms', 'warn');
        setTimeout(() => reject(new Error('KNB ready function over time more than 5000ms')), 5000);
      })
    ]);
  }

  _sharePretreat(opts = {}) {
    const { channel, desc, content, title } = opts;
    const newOpts = Object.assign(opts);

    Array.isArray(channel) && (newOpts.channel = channel.map((v) => window.KNB.share[v]));

    if (!content) {
      // optimize 可以考虑使用 KNB.getUA 的方法，但是这个是一个 callback 形式
      newOpts.content = new RegExp('waimai', 'g').test(window.navigator.userAgent) ? desc : title;
    }

    return newOpts;
  }

  configShare(opts = {}) {
    const newOpts = this._sharePretreat(opts);
    this._execSDK('configShare', newOpts);
  }

  share(opts = {}) {
    const newOpts = this._sharePretreat(opts);
    this._execSDK('share', newOpts);
  }

  pureUse(opts = {}) {
    const { method, ...args } = opts;
    if (!method) {
      opts.fail('[KNB] call pureUse args need include method!');
      return;
    }

    // 因为特殊的方式，所有暂时先这样进行支持
    window.KNB.pureUse(method, args);
  }
};
